import { useContext } from "react";
import React from "react";
import { Dropdown, DropdownProps, Input, Table } from "semantic-ui-react";
import { OwnershipProps, QAPropsBase, State } from "../State";
import { Action, store } from "../store";
import ComponentSwitcher from "../components/ComponentSwitcher";
import EnumeratedTable from "../components/EnumeratedTable";


interface Props {
    index: number;
    propsBase: QAPropsBase;
}

function handlePercentOrVSChange(o: OwnershipProps[], index: number, answerIndex: number, d: DropdownProps, dispatch: React.Dispatch<Action>, s: State): void {
    const newOwnershipState = o.map((v, i) => {
        if (index === i) {
            return { ...v, percentageOrVotingStock: parseInt(`${d.value}`, 10) || 0 };
        } else {
            return { ...v };
        }
    });
    dispatch({ type: "handle answer update", value: newOwnershipState, index: answerIndex });
}


function handleNameChange(o: OwnershipProps[], e: React.ChangeEvent<HTMLInputElement>, index: number, answerIndex: number, dispatch: React.Dispatch<Action>, s: State): void {
    const newOwnershipState = o.map((v, i) => {
        if (index === i) {
            return { ...v, name: e.target.value };
        } else {
            return { ...v };
        }
    });
    dispatch({ type: "handle answer update", value: newOwnershipState, index: answerIndex });
}


function handleAmountChange(o: OwnershipProps[], e: React.ChangeEvent<HTMLInputElement>, index: number, answerIndex: number, dispatch: React.Dispatch<Action>, s: State): void {
    const newOwnershipState = o.map((v, i) => {
        if (index === i) {
            return { ...v, amount: parseInt(e.target.value, 10) || 0 };
        } else {
            return { ...v }; 
        }
    });
    dispatch({ type: "handle answer update", value: newOwnershipState, index: answerIndex });
}


const OwnershipTableAnswer: React.FunctionComponent<Props> = (props: Props) => {
    const globalState = useContext(store);
    const { dispatch } = globalState;

    return (
        <div>
            <ComponentSwitcher index={props.index}
                action={{ type: "handle answer update" }}
                answerContent={" : ;Owners:1;Board of Directors:0"}
                questionContent={"DOES ENTITY HAVE OWNERS OR BOARD OF DIRECTORS?"}
                arrayProjector={[
                    (o) => o.map((w: OwnershipProps) => { return { name: w.name, amount: w.amount, percentageOrVotingStock: w.percentageOrVotingStock, ownerOrMember: 0 } }),
                    (o) => o.map((w: OwnershipProps) => { return { name: w.name, amount: w.amount, percentageOrVotingStock: w.percentageOrVotingStock, ownerOrMember: 1 } }),
                ]}
                source={props.propsBase.answerValue as OwnershipProps[]}
                defaultValue={"1"}
                content={[
                    <EnumeratedTable index={props.index}
                            action={{ type: "handle answer update" }}
                            generator={() => ({ name: "", ownerOrMember: 0 })}
                            inverted={globalState.state.appState.isDarkTheme}
                            questionContent={"HOW MANY MEMBERS OF THE BOARD OF DIRECTORS?"}
                            source={props.propsBase.answerValue as OwnershipProps[]}>
                            {
                                (props.propsBase.answerValue as OwnershipProps[]).map((o, i) =>
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        <Input size={"small"} fluid type={"text"} value={o.name} placeholder={"Name"}
                                            style={{ minWidth: "250px" }}
                                                onChange={(e) => handleNameChange(props.propsBase.answerValue as OwnershipProps[],
                                                    e, i, props.index, dispatch, globalState.state)}
                                        />
                                    </Table.Cell>
                                </Table.Row>)
                            }
                    </EnumeratedTable>,
                    <EnumeratedTable index={props.index}
                            action={{ type: "handle answer update" }}
                            generator={() => ({ name: "", ownerOrMember: 1 })}
                            inverted={globalState.state.appState.isDarkTheme}
                            questionContent={"HOW MANY OWNERS ARE THERE?"}
                            source={props.propsBase.answerValue}>
                            {
                                (props.propsBase.answerValue as OwnershipProps[]).map((o, i) =>
                                <Table.Row key={i}>
                                    <Table.Cell>
                                        <Input size={"small"} type={"text"} value={o.name} placeholder={"Name"}
                                            style={{ minWidth: "250px" }} fluid
                                                onChange={(e) => handleNameChange(props.propsBase.answerValue as OwnershipProps[],
                                                    e, i, props.index, dispatch, globalState.state)}
                                        />
                                    </Table.Cell>
                                    {
                                        <Table.Cell error={((props.propsBase.answerValue as OwnershipProps[])
                                            .map((s) => s.amount)
                                            .reduce((a, c) => (a || 0) + (c || 0)) || 0) > 100}>
                                            <Input size={"small"} type={"number"}
                                                max={100} min={0} value={o.amount}
                                                    onChange={(e) => handleAmountChange(props.propsBase.answerValue as OwnershipProps[],
                                                        e, i, props.index, dispatch, globalState.state)}
                                                label={
                                                    <Dropdown defaultValue="0"
                                                        options={[
                                                        { key: "percentage", text: "%", value: "0" },
                                                        { key: "votestock", text: "votes", value: "1" },
                                                        ]}
                                                        onChange={(e, d) => handlePercentOrVSChange(props.propsBase.answerValue as OwnershipProps[],
                                                            i, props.index, d, dispatch, globalState.state)}
                                                    />
                                                }
                                                labelPosition={"right"} content={o.amount} style={{ maxWidth: "100px", marginRight: "50px" }}
                                            />
                                        </Table.Cell>
                                    }
                                </Table.Row>)
                            }
                        </EnumeratedTable>,
                ]}
            />
      </div>
    );
  };

export default OwnershipTableAnswer;
